import EDITOR_MODES from 'crazyEditor/core/constants/editorConstants';
import React, { Component } from 'react';
import { EDITOR_APP_WRAPPER_ID } from 'crazyEditor/core/constants/editorConstants';
import { DragDropContext } from 'react-dnd';
import { Provider } from 'react-redux';
import _ from 'lodash';
import HTML5Backend from 'react-dnd-html5-backend';
import NotificationSystem from 'react-notification-system';
import {notificationSystemProps} from 'shared/helpers/onScreenNotificationHelper';
import {getNewStore, store} from 'crazyEditor/redux/store';
import {Main} from '../';
import $ from 'jquery';
import {createTemplateService, templateService, closeTemplateService} from 'shared/helpers/TemplateService';
import { REPLACE_STORE } from 'crazyEditor/redux/modules/element/actions/generalActions';
import { SET_NOT_PREFETCHED } from 'crazyEditor/redux/modules/template/template';
import {eventOnFirstTime} from 'shared/helpers/analyticsHelper';
import * as routes from 'App/routeConstants';
import IntegrationConnector from 'shared/components/Integration/IntegrationConnector';
import { getStoredTemplate } from 'crazyEditor/core/utils/storage';
import RealTimeDBListener from 'shared/realTimeDB/RealTimeDBListener';
import {getInitialStore} from 'shared/utils/editorStoreUtils';
import UtilsProvider from 'shared/utils/UtilsProvider';
import connectWithRouter from 'shared/components/redux/connectWithRouter';

require('normalize.css');
require('./App.scss');

const styles = {
  width: '100%',
  height: '100%',
  position: 'relative',
  zIndex: 0
};

@connectWithRouter(
  (state) => ({
    templateId: state.routing.location.query.id,
    query: state.routing.location.query,
  })
)
@DragDropContext(HTML5Backend)
export default class App extends Component {
  state = {
    readyToRender: false,
  };

  componentWillMount() {
    const { desktopElementsFromLS } = getStoredTemplate();
    if (!desktopElementsFromLS.elements && typeof store.getState().template.id === 'undefined') {
      console.warn('Template does not exist! Rerouting to ', routes.MyAccount.ViewTemplatesBase);
      this.props.router.replace({pathname: routes.MyAccount.ViewTemplatesBase});
    }

    _.defer(() => {
      $('*[data-analytics-event]').on('click', function handleClick() {
        const analyticsEvent = $(this).data('analytics-event');
        const trackProperties = {};
        window.analytics.track(analyticsEvent, trackProperties);
        eventOnFirstTime(`${analyticsEvent} First Time`);
      });
    });

    window.analytics.track('Editor');
    eventOnFirstTime('Editor First Time');

    if (desktopElementsFromLS.elements || store.getState().template.prefetched) {
      this.initEditor();
    } else {
      this.loadEditorStore(this.props);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.templateId !== this.props.templateId && store.getState().editor.isQuickPreviewMode) {
      this.loadEditorStore(nextProps);
    }
    if (this.props.query.mode === EDITOR_MODES.QUICK_PREVIEW && nextProps.query.mode !== EDITOR_MODES.QUICK_PREVIEW) {
      templateService.preventConfirmNavigation();
    }
  }

  componentWillUnmount() {
    closeTemplateService();
    window.removeEventListener('beforeunload', this.promptUserForUnsavedChanges);
    store.dispatch({type: SET_NOT_PREFETCHED});
  }

  loadEditorStore(props) {
    getInitialStore(props.query, (storeData) => {
      store.dispatch({type: REPLACE_STORE, newState: getNewStore(storeData).getState()});
      this.initEditor();
    });
  }

  leaveEditor = () => {
    return this.promptUserForUnsavedChanges();
  };

  initEditor = () => {
    if (this.editorInitilized) {
      return;
    }
    this.editorInitilized = true;
    createTemplateService();
    this.props.router.setRouteLeaveHook(this.props.route, this.leaveEditor);
    window.addEventListener('beforeunload', this.promptUserForUnsavedChanges);
    this.setState({readyToRender: true});
  };

  promptUserForUnsavedChanges = (event) => {
    if (templateService.hasUnsavedChanges() && !store.getState().editor.isQuickPreviewMode) {
      const confirmationMessage = 'You have unsaved changes that will be lost if you decide to continue. Are you sure you want to leave this page?';
      if (event) {
        event.returnValue = confirmationMessage;
      }
      return confirmationMessage;
    }
    return _.noop();
  };

  render() {
    const {readyToRender} = this.state;
    if (!readyToRender) {
      return null;
    }
    return (
      <Provider store={store}>
        <IntegrationConnector id={EDITOR_APP_WRAPPER_ID} style={styles}>
            <RealTimeDBListener/>
            <UtilsProvider>
              <Main/>
            </UtilsProvider>
            <NotificationSystem {...notificationSystemProps}/>
        </IntegrationConnector>
      </Provider>
    );
  }
}
